import { MEDIA_KINDS, normalizeMediaSource } from '../../../media/mediaSource';
import { isSlotAwaitingImage, MEDIA_OBJECT_SLOT } from '../../../utils/imageSlots';
import { plainText } from '../../../utils/richTextHtml';

export function carouselThumbnails(slides = []) {
  return slides.map((slide, index) => {
    const content = normalizeMediaSource(slide.contentMedia);
    const background = normalizeMediaSource(slide.backgroundMedia);
    if ([content, background].some((media) => media.src && media.kind !== MEDIA_KINDS.image)) return null;
    const image = content.src ? content : background;
    if (!image.src || isSlotAwaitingImage(image, MEDIA_OBJECT_SLOT)) return null;
    return { src: image.src, srcSet: image.srcVariable?.variableKey ? '' : image.srcset, label: plainText(slide.title) || `Photo ${index + 1}` };
  });
}

export function thumbnailsUnavailableReason({ maxSlidesVisible, scrollAxis, slidesVisible, slides = [] }) {
  if (maxSlidesVisible || scrollAxis === 'vertical' || Number(slidesVisible || 1) !== 1) {
    return 'Les miniatures sont disponibles pour un diaporama horizontal avec une seule slide visible.';
  }
  if (slides.length < 2 || carouselThumbnails(slides).some((image) => !image)) {
    return 'Chaque slide doit contenir une photo renseignée. Les vidéos ne proposent pas de miniatures de navigation.';
  }
  return '';
}
